/**
 * Service for Category funcs..
 */


(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxCategorySvc', ItxCategorySvc);

    ItxCategorySvc.$inject = ['Category'];

    var cacheCategory = [];
    function ItxCategorySvc(Category){

        function avoidGridSpaces  (products) {
        var _this = this;
        var itemsBeforeDoubleBox = 0;
        var reorderedProducts = products;

        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            if (!product.config.isDoubleBox && !product.config.isVerticalBox) {
                itemsBeforeDoubleBox += 1;
            }

            if(product.config.isVerticalBox){
               var j;
               var blockspaces;
               var offset; 
               if(itemsBeforeDoubleBox % 2 === 1 && !reorderedProducts[i-3].config.isVerticalBox ){
                reorderedProducts = _this.swapArrayElements(reorderedProducts, i-1, i);
                j = i+1;
                itemsBeforeDoubleBox = 1;
                blockspaces = 1;
                offset = 1;
               }
               else{
                j = i+1;
                itemsBeforeDoubleBox = 0;
                blockspaces = 2;
                offset = 2;
               }
                while(blockspaces > 0 && j < products.length){
                    if(blockspaces === 2){
                        if( products[j].config.isVerticalBox ){
                            blockspaces -=2;
                            ++i;
                            itemsBeforeDoubleBox = 0;
                        }
                        else if( products[j].config.isDoubleBox ){
                            _this.swapArrayElements(reorderedProducts, i, j);
                            blockspaces -=2;
                        }
                        else{
                            blockspaces -=1;
                        }
                    }
                    else if(blockspaces === 1){
                        while (products[j] && (products[j].config.isDoubleBox ||  products[j].config.isVerticalBox ) ) {
                            j++;
                        }
                        if (products[j]) {
                            reorderedProducts = _this.swapArrayElements(reorderedProducts, i+offset, j);
                            blockspaces -=1;
                        }
                    }
                    ++j;
                }
               
             
            }
            else if (product.config.isDoubleBox) {
                if (itemsBeforeDoubleBox % 2 === 1) {
                    var nextIndexNotDouble = i + 1;
                    while (products[nextIndexNotDouble] && (products[nextIndexNotDouble].config.isDoubleBox || products[nextIndexNotDouble].config.isVerticalBox) ) {
                        nextIndexNotDouble++;
                    }
                    if (products[nextIndexNotDouble] && !products[nextIndexNotDouble].config.isDoubleBox) {
                        reorderedProducts = _this.swapArrayElements(reorderedProducts, i, nextIndexNotDouble);
                    }
                    i = nextIndexNotDouble;
                }
                itemsBeforeDoubleBox = 0;
            }

        }
        return reorderedProducts;
    }

    function swapArrayElements (arr, indexA, indexB) {
        var temp = arr[indexA];
        arr[indexA] = arr[indexB];
        arr[indexB] = temp;
        return arr;
    }

    
    function getCategory (categoryId){
        
        var category;
        //Miramos si tenemos la categoría cacheada.
        if (!cacheCategory[categoryId]) {
            category = joyr.utils.findCategory(categoryId, inditex.iCategoryTreeJSON.categories);

            if(!category && inditex.iCategoryTreeJSON.hiddenCategories){
                category = joyr.utils.findCategory(categoryId, inditex.iCategoryTreeJSON.hiddenCategories);
            }

            category = new Category(category); //jshint ignore:line
            cacheCategory[categoryId] = category;

        } else {
            category = cacheCategory[categoryId];
        }

    
        //Si no es una categoría estandard o cambiamos de tipo de vista, refrescamos la URL..
        if (category.isStandard() || (inditex.iCategoryJSON && category.type != inditex.iCategoryJSON.type)) {

            window.location.href = category.getUrl();
        } else {
            //Si es una redirección, refrescamos..
            if (category.viewCategoryId !== 0) {
                return getCategory(category.viewCategoryId);
            }
            else{
                return category;
            }
            // set properties 
        }
    }

        return {
            avoidGridSpaces:avoidGridSpaces,
            swapArrayElements:swapArrayElements,
            getCategory: getCategory
        };
    }


    

})();

